import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { SVGCommon } from '../../Svg/CommonSvg';
import { removeDefaultParams } from '../../Utils/helper';
import {
  BreadCrumbsArrowSvg,
  BreadcrumbsList,
  CategoryBreadcrumbs,
} from '../StoreCategoryPage/Breadcrumbs/styled';

export default function BreadCrumbs(props) {
  const { removeId } = props;
  const router = useRouter();
  const array = router.asPath.split('?');
  const actualPath = array?.[0]?.split('/');
  const slicedArray = actualPath.slice(1, actualPath.length);
  if (removeId) {
    const lastItem = slicedArray[slicedArray.length - 1];
    const lastItemArray = lastItem.split('-');
    lastItemArray.pop();
    const lastItemUpdated = lastItemArray.join(' ');
    slicedArray.pop();
    slicedArray.push(lastItemUpdated);
  }

  const generateBreadCrumbs = () => {
    return slicedArray?.map((path, index) => {
      let url =
        index < slicedArray.length - 1
          ? '/' + slicedArray.slice(0, index + 1).join('/')
          : '';
      return path != 'starting-with' &&
        path != 'unique-baby-names' &&
        path != 'health-packages' &&
        path != 'expert-profile' &&
        path != 'partnership-products' ? (
        <Link
          href={{
            pathname: url,
            query: removeDefaultParams(router.query),
          }}
          passHref
          key={`breadcrumbs${index}`}
          prefetch={false}
          locale={false}
          legacyBehavior
        >
          <BreadcrumbsList
            as={url ? 'a' : ''}
            className={url ? 'greenColor ' : ''}
          >
            {path}
            <BreadCrumbsArrowSvg
              className={slicedArray?.length - 1 == index ? 'hideArrow' : ''}
            >
              <SVGCommon id="arrowdownforward" />
            </BreadCrumbsArrowSvg>
          </BreadcrumbsList>
        </Link>
      ) : null;
    });
  };
  return (
    <CategoryBreadcrumbs className={'addClass'}>
      <ul>{generateBreadCrumbs()}</ul>
    </CategoryBreadcrumbs>
  );
}
